import React from 'react';
import { LogoSvg } from './styles';
const Logo = () => {
    return (
        <LogoSvg width="30" height="28" viewBox="0 0 30 28" fill="none" xmlns="http://www.w3.org/2000/svg">
            <g clip-path="url(#clip0_35_91)">
            <path d="M14.7363 17.4567V0.5H23.2426V8.53127C23.2426 14.0238 18.6623 16.7702 14.7363 17.4567Z" fill="black"/>
            <path d="M6 17.606H14.5063V26.5314C9.25401 25.1442 7.27986 23.3135 6 17.606Z" fill="black"/>
            </g>
            <defs>
            <clipPath id="clip0_35_91">
            <rect width="18" height="27" fill="white" transform="translate(6 0.5)"/>
            </clipPath>
            </defs>
        </LogoSvg>

    );
};

export { Logo };
